<template>
  <div id="app">

    <!-- NAVBAR -->
    <navbar-view />

    <!-- MAIN -->
    <main class="main-content">
      <transition name="page" mode="out-in">
        <router-view />
      </transition>
    </main>

    <!-- FLOATING BUTTONS -->
    <div class="floating-actions">

      <!-- WhatsApp -->
      <a
        v-if="site.whatsapp"
        :href="`https://wa.me/${site.whatsapp}`"
        target="_blank"
        rel="noopener"
        class="floating-btn whatsapp"
        aria-label="Nous écrire sur WhatsApp"
      >
        <i class="bi bi-whatsapp"></i>
      </a>

      <!-- Back To Top -->
      <button
        class="floating-btn top-btn"
        aria-label="Remonter en haut de la page"
        @click="scrollTop"
      >
        <i class="bi bi-arrow-up"></i>
      </button>

    </div>

    <!-- FOOTER -->
    <footer-view />

  </div>
</template>

<script setup>
import NavbarView from './components/NavbarView.vue'
import FooterView from './components/FooterView.vue'
import { useSite } from './composables/useSite'

// Coordonnées et réseaux gérés depuis l'admin (Paramètres du site)
const site = useSite()

function scrollTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}
</script>

<style>

/* IMPORT GOOGLE FONT */
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

/* BOOTSTRAP ICONS */
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css");

/* RESET */
*{
  margin:0;
  padding:0;
  box-sizing:border-box;
}

html{
  scroll-behavior:smooth;
}

body{
  padding-top: 80px;
  font-family:'Poppins',sans-serif;
  background:#f8fafc;
  color:#0F2B45;
  overflow-x:hidden;
}
html, body {
  overflow-x: hidden !important;
  max-width: 100%;
}

/* GLOBAL CONTAINER */
.container{
  width:90%;
  max-width:1300px;
  margin:auto;
}

/* MAIN */
.main-content{
  min-height:100vh;
  padding-top:90px;
  overflow-x:hidden;
}
img {
  max-width: 100%;
  display: block;
}

/* PAGE TRANSITION */
.page-enter-active,
.page-leave-active{
  transition:all .4s ease;
}
section {
  overflow-x: hidden;
}

.page-enter-from{
  opacity:0;
  transform:translateY(20px);
}

.page-leave-to{
  opacity:0;
  transform:translateY(-20px);
}

/* GLOBAL BUTTON */
.btn{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  gap:10px;
  text-decoration:none;
  cursor:pointer;
}

/* FLOATING BUTTONS */
.floating-actions{
  position:fixed;
  right:20px;
  bottom:20px;
  z-index:9999;
  display:flex;
  flex-direction:column;
  gap:15px;
}

.floating-btn{
  width:58px;
  height:58px;
  border:none;
  border-radius:50%;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:1.5rem;
  cursor:pointer;
  text-decoration:none;
  box-shadow:0 10px 25px rgba(0,0,0,0.15);
  transition:all .3s ease;
}

.floating-btn:hover{
  transform:translateY(-5px) scale(1.05);
}

/* WHATSAPP */
.whatsapp{
  background:#25D366;
  color:white;
}

/* TOP BUTTON */
.top-btn{
  background:#0F2B45;
  color:#F0C95C;
}

/* SCROLLBAR */
::-webkit-scrollbar{
  width:10px;
}

::-webkit-scrollbar-track{
  background:#f1f5f9;
}

::-webkit-scrollbar-thumb{
  background:#0F2B45;
  border-radius:10px;
}

::-webkit-scrollbar-thumb:hover{
  background:#163d61;
}

/* RESPONSIVE */
@media(max-width:768px){

  body{
  padding-top: 0px;
  font-family:'Poppins',sans-serif;
  background:#f8fafc;
  color:#0F2B45;
  overflow-x:hidden;
}

  .container{
    width:92%;
  }

  .floating-btn{
    width:52px;
    height:52px;
    font-size:1.3rem;
  }

  .main-content{
    padding-top:80px;
  }

}

</style>